"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * Tree-shakeable icon component for reply/comment indicators.
 */
var Reply = function Reply(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M10.8 0.5H1.2C0.54 0.5 0 1.04 0 1.7V12.5L2.4 10.1H10.8C11.46 10.1 12 9.56 12 8.9V1.7C12 1.04 11.46 0.5 10.8 0.5Z",
    fill: "currentColor"
  }));
};

var _default = Reply;
exports.default = _default;